<template>
   <div class="container">
   </div>
</template>

<script>
import { extendUA } from '@/utils/extend-ua'
export default {
  data () {
    return {}
  },
  created() {
    this.$daidiLoading.show({
      text: '正在跳转中...',
    })
    this.navToMini()
  },
  mounted() {
  },
  methods:{
    navToMini(){
      let encodeUrl = ''
      let params = window.location.href.split('?')[1]
      let paramsArr = params.split('&')
      let paramsObj = {}
      for (let i = 0; i< paramsArr.length; i++) {
        let item = paramsArr[i].split('=')
        paramsObj[item[0]] = item[1]
      }
      console.log(window.location.href, paramsObj.path)
      console.log('paramsObj', paramsObj)
      if (!paramsObj.path || !paramsObj.username) {
        this.$toast.show({
          text: '找不到相关内容',
          duration: 3000
        })
        this.$daidiLoading.hide()
        setTimeout(() => {
          window.location.href = '/exitInWebView'
        }, 2000)
        return
      }
      // 解码
      let url = decodeURIComponent(paramsObj.path)
      if (extendUA.isIlistenIOS) {
         encodeUrl = encodeURIComponent(
          url
        )
      }
      // 安卓客户端解码了2次，所以需要特殊处理，编码2次
      if (extendUA.isIlistenAndroid) {
        encodeUrl = encodeURIComponent(
          encodeURIComponent(
            url
          )
        )
      }
      let type = !paramsObj.type ? '' : paramsObj.type
      window.location.href = `ilisten:///openmp?username=${paramsObj.username}&path=${encodeUrl}&type=${type}`
      this.$daidiLoading.hide()
      setTimeout(() => {
        window.location.href = '/exitInWebView'
      }, 1)
    }
  }
}
</script>
<style scoped lang="less">
  .container{
    height: 100vh;
  }
</style>